<div class="row">
    <div class="col-12">
        <input-value-start-end [title]="'Lạm phát'"
            [hintText]="'Thiết lập tỷ lệ tăng trưởng dự kiến của lạm phát hàng năm để tính phân bổ chi tiêu trong tương lai, kế hoạch nghỉ hưu và mục tiêu tài chính khác cho khách hàng. Đây là thiết lập mức chung, bạn có thể tùy chỉnh riêng cho từng hồ sơ HĐTC.'"
            [updateTime]="config?.updateTime" [list]="list" [typeId]="typeId">
        </input-value-start-end>
    </div>
</div>